import { graphql } from 'gql'

export const ACTIVATE_ALL_AD_UNITS_PRODUCT = graphql(`
  mutation activateAllAdUnitsProduct($input: ActivateAllAdUnitsProductInput!) {
    activateAllAdUnitsProduct(input: $input) {
      errors {
        ...ErrorFragment
      }
    }
  }
`)
